var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//import nem from 'nem-sdk';
import localForage from 'localforage';
//import axios from 'axios';
import crypto from 'crypto-js';
var helper = /** @class */ (function () {
    function helper() {
        this.key = '';
        //path:string = 'http://localhost:3000/api/v1/'
        this.path = 'https://mgt.smart-uq.com/api/v1/';
    }
    helper.prototype.Encrypt = function (word) {
        return crypto.AES.encrypt(word, this.key).toString();
    };
    helper.prototype.Decrypt = function (word) {
        return crypto.AES.decrypt(word, this.key).toString(crypto.enc.Utf8);
    };
    helper.prototype.save = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, localForage.setItem(key, value)];
                    case 1:
                        result = _a.sent();
                        console.log(result);
                        console.log("save...");
                        return [2 /*return*/];
                }
            });
        });
    };
    helper.prototype.load = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, localForage.getItem(key)];
                    case 1:
                        result = _a.sent();
                        console.log("loading..." + key);
                        console.log("result");
                        console.log(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    helper.prototype.loadHeaders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, localForage.getItem("Headers")];
                    case 1:
                        result = _a.sent();
                        console.log("loading... headers");
                        console.log("result");
                        console.log(result);
                        if (result == null || result["access-token"] == null) {
                            console.log("=========please login=========");
                            this.pleaseLogin();
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    helper.prototype.saveData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var key, d, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, this.toAESJSON(data.address, data.private_key, data.public_key)];
                    case 1:
                        d = _a.sent();
                        return [4 /*yield*/, localForage.setItem(key, d)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    helper.prototype.pleaseLogin = function () {
        console.log("=========please login!=========");
        this.deleteLocalStrage();
    };
    helper.prototype.deleteLocalStrage = function () {
        localForage.clear();
        this.reload();
    };
    helper.prototype.reload = function () {
        window.location.href = '/';
    };
    helper.prototype.toAESJSON = function (address, privateKey, publicKey) {
        var AESprivateKey = this.Encrypt(privateKey);
        console.log("暗号化＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝");
        console.log(AESprivateKey);
        return {
            address: address,
            privateKey: AESprivateKey,
            publicKey: publicKey
        };
    };
    helper.prototype.saveInitialData = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = JSON.parse(result);
                        console.log(result);
                        console.log(result["user_info"][0]);
                        console.log(result["company_info"][0]);
                        console.log(result["account_list"]);
                        return [4 /*yield*/, this.save("User-Info", result["user_info"][0])];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.save("Company-Info", result["company_info"][0])];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.save("Account-List", result["account_list"])];
                    case 3:
                        _a.sent();
                        location.reload();
                        return [2 /*return*/];
                }
            });
        });
    };
    return helper;
}());
export default helper;



//////////////////
// WEBPACK FOOTER
// ./src/ts/helper.ts
// module id = 28
// module chunks = 1